export const INTERNAL_MESSAGE_ERROR_KEY = '[Internal Message Error]';
export const INTERNAL_MESSAGE_SOURCE = 'pimster-embed';
export const INTERNAL_MESSAGE_ALLOWED_SOURCES = [
  'pimster-pim',
  'pimster-embed-server',
];
